export class Child{
    id?: number;
    name: string;
    birthdate: string;
    gender: string;
    civil_status: string;
    age: number;
    spouse_name: string;
    minister_id?: number;
    
    constructor()
    {
        this.id = null;
        this.name = null;
        this.birthdate = null;
        this.gender = null;
        this.civil_status = null;
        this.age = null;
        this.spouse_name = null;
        this.minister_id = null;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/Child.model.ts